import HlxButton from 'component/commonComponents/button/button';
import React from 'react';
import { useTheme } from 'styled-components';
import GeneralDialog from '../generalDialog/generalDialog';
import { StyledBannerContent } from './banner.style';

export interface BannerProps {
  open: boolean;
  onClick?: () => void;
  title?: string;
  content?: string;
  btnLabel?: string;
  logoUrl?: string;
  locale?: {
    [key: string]: string;
  };
}

const Banner = (props: BannerProps) => {
  const { open, onClick, title, content, btnLabel, logoUrl, locale } = props;

  const theme = useTheme();

  const dialogContent = (
    <StyledBannerContent>
      {logoUrl && (
        <div className="logo">
          <img src={logoUrl} alt="" id="img-banner-logo"/>
        </div>
      )}
      <div id="lbl-banner-content">{content || locale?.content || ''}</div>
    </StyledBannerContent>
  );

  return (
    <GeneralDialog
      isOpen={open}
      title={title || locale?.title || ''}
      content={dialogContent}
      justifyContentAction="center"
      hideButtonCancel
      hideCloseIcon
      headerBackgroundDefault={false}
      maxWidth="xs"
      buttonSubmit={<HlxButton label={btnLabel || locale?.btnLabel || ''} onClick={onClick} />}
      handleClose={() => {}}
      commonStyles={{
        padding: `${theme.uptimeSpace[12]}px ${theme.uptimeSpace[12]}px 0 !important`,
        contentFontSize: theme.uptimeFontSizes.desktop.fz7,
      }}
      actionStyles={{
        padding: `${theme.uptimeSpace[12]}px 0`,
        btnWidth: '200px',
      }}
    />
  );
};

export default Banner;
